import { GlobalNotificationBar } from '@aibees/shared/features';
import { DashboardLayoutOptions } from '@aibees/shared/layouts/dashboard/types';

export const options = {
  topElement: <GlobalNotificationBar />,
  navigation: {
    config: {
      itemGap: 12,
      sx: {
        pb: 2,
      },
    },
  },
} satisfies DashboardLayoutOptions;
